import { create } from 'zustand';

type State = {
  rotateVault: (range: number) => void;
  fadeVaultIn: () => void;
  showInputSequence: boolean;
  percentCompleted: number;
  progressStep: number;
  user: {
    email: string | null;
    password: string | null;
  };
};

type Action = {
  setRotateVault: (rotateVault: (range: number) => void) => void;
  setFadeVaultIn: (fadeVaultIn: () => void) => void;
  setShowInputSequence: (showInputSequence: boolean) => void;
  setPercentCompleted: (percentCompleted: number) => void;
  setProgressStep: (stepId: number) => void;

  setEmail: (text: string) => void;
  setPassword: (text: string) => void;

  nextStep: () => void;
  previousStep: () => void;
};

const useOnboardingStore = create<State & Action>((set) => ({
  rotateVault: () => {},
  fadeVaultIn: () => {},
  showInputSequence: false,
  percentCompleted: 0,
  progressStep: 0,
  user: {
    name: null,
    email: null,
    password: null,
  },

  setRotateVault: (func) => set(() => ({ rotateVault: func })),
  setFadeVaultIn: (func) => set(() => ({ fadeVaultIn: func })),
  setShowInputSequence: (show) => set(() => ({ showInputSequence: show })),
  setPercentCompleted: (percentCompleted) =>
    set(() => ({ percentCompleted: percentCompleted })),
  setProgressStep: (stepId) => set(() => ({ progressStep: stepId })),

  setEmail: (text) =>
    set((state) => ({ user: { ...state.user, email: text } })),
  setPassword: (text) =>
    set((state) => ({ user: { ...state.user, password: text } })),

  nextStep: () => set((state) => ({ progressStep: state.progressStep + 1 })),
  previousStep: () =>
    set((state) => ({ progressStep: Math.max(0, state.progressStep - 1) })),
}));

export default useOnboardingStore;
